import { ExternalLink } from "lucide-react";

const ADDRESS =
  "Growing IT Solutions, B521, Money Plant High Street, Jagatpur Road, Gota, Ahmedabad, Gujarat 382470, India";
const Q = encodeURIComponent(ADDRESS);
const EMBED = `https://maps.google.com/maps?q=${Q}&z=15&output=embed`;
const OPEN = `https://www.google.com/maps/search/?api=1&query=${Q}`;

export default function LocationMap({ className = "", height = "h-[380px]" }) {
  return (
    <div
      data-testid="location-map"
      className={`relative border border-white/10 overflow-hidden bg-[#0F111A] ${className}`}
    >
      <a
        href={OPEN}
        target="_blank"
        rel="noreferrer"
        data-testid="open-in-maps"
        className="absolute top-4 left-4 z-10 inline-flex items-center gap-2 bg-white text-[#003F7A] font-semibold text-sm px-4 py-2.5 rounded shadow-lg hover:bg-slate-100 transition-colors"
      >
        Open in Maps <ExternalLink className="w-4 h-4" />
      </a>
      <iframe
        title="Growing IT Solutions office location"
        src={EMBED}
        className={`w-full ${height} block`}
        style={{ border: 0, filter: "grayscale(0.15) contrast(1.05)" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
